module.exports = "/_next/static/images/d0628d1cad01e33d93f473387da752c1-dress-code-3.png.webp";